import React from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import ArtPieceSharedDetails from "./SharedDetails"
import { ART_PIECE_DRAWING_TAG_BACKGROUND } from "../../../api/Definitions"

const ArtPieceDrawing = () => {
  return (
    <div className="container">
      <ArtPieceSharedDetails />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="drawing.width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width"
          />
        </div>
        <div className="col-6">
          <FormInput
            name="drawing.height"
            label="Height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
      <AsyncCreatableTag
        name="drawing.background"
        group={ART_PIECE_DRAWING_TAG_BACKGROUND}
        label="Background"
        placeholder="E.g. Paper, Newspaper, Canvas..."
      />
      <FormInput
        name="drawing.edition"
        label="Edition"
        placeholder="E.g. Limited edition, Author print..."
      />
    </div>
  )
}

export default ArtPieceDrawing
